import { render, staticRenderFns } from "./WorkerReview.vue?vue&type=template&id=41b67062&"
import script from "./WorkerReview.vue?vue&type=script&lang=js&"
export * from "./WorkerReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports